import angular from 'angular';
import uiRouter from 'angular-ui-router';
import v2Component from './v2.component';

let v2Module = angular.module('v2', [
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider

  .state('v2', {
    url: '/v2',
    template: '<v2></v2>',
    authenticate: true
  })

})

.component('v2', v2Component);

export default v2Module;



// WEBPACK FOOTER //
// ./client/app/components/v2/v2.js